// extracted by mini-css-extract-plugin
export default {"container":"lJ-z","error":"mJ-z","disabled":"nJ-z","submit":"oJ-z","option":"pJ-z","success":"qJ-z","failure":"rJ-z"};